import React from "react";
import { useNavigate } from "react-router-dom";

import "./ServiceCard.css";
import { servicesData } from "./service_data";

function Services() {
  const navigate = useNavigate();

  const handleCardClick = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };

  return (
    <>
      {/* HEADING */}
      <h1 className="service_heading" id="services">
        <span>Services</span> We Are Offering
      </h1>
      <div style={{"background-color": "#f5f6f8"}}>
      <p className="service_subheading">
 From general maintenance to complete installations, we provide reliable solutions for all your service needs.

</p></div>

      {/* SERVICES */}
      <div className="services">

        {servicesData.map((service) => (
          <div
            className="service_card"
            key={service.id}
            onClick={() => handleCardClick(service.id)}
          >

            {/* IMAGE */}
            <div className="card_image">
              <img src={service.img} alt={service.title} />
            </div>

            {/* CONTENT */}
            <div className="card_content">

              {/* ICON */}
              <div className="card_icon">
                <img src={service.icon} alt={service.title} />
              </div>

              {/* TITLE */}
              <h3>{service.title}</h3>

              {/* DESCRIPTION */}
              <p>{service.desc}</p>

            </div>

          </div>
        ))}

      </div>
    </>
  );
}

export default Services;